import { PageHeader } from "@/design-system/PageHeader";

import { ProductionRelease } from "./ProductionRelease";

/**
 * Система for the platform administrator: no account is in scope, so the
 * screen is the release itself — which code runs, whether it agrees with
 * itself, and where it would roll back to. Read-only by contract §12.2.
 */
export function PlatformSystemPage(): React.JSX.Element {
  return (
    <div className="flex flex-col gap-2">
      <PageHeader
        title="Система"
        description="Всё ли в порядке с установленной версией платформы."
      />
      <ProductionRelease />
    </div>
  );
}
